import styles from './Heading.module.scss';
import React from 'react';
import { useAlgoliaAppContext } from '../../../hooks/useAlgoliaAppContext';
import { MEDIA_BREAKPOINTS } from '../../../../constants/MEDIA_BREAKPOINTS';
export const HeadingTitleSkeleton = () => {
    const { pagePath } = useAlgoliaAppContext();
    const isCollection = pagePath === 'collections';
    return (React.createElement("div", { className: "d:grid gtc:2:auto as:start jc:start" },
        isCollection &&
            React.createElement("div", { className: "skeleton bdrs:2 h:48 w:48 h:72:md-up w:72:md-up mr:14 mr:24:md-up" }),
        React.createElement("div", { className: "d:flex fd:column ai:start jc:between" },
            React.createElement("div", { className: "skeleton ff:abril-display lh:0.9 fz:32 fz:48:md-up bdrs:2 h:lh w:128 w:208:md-up mt:0" }),
            isCollection &&
                React.createElement("div", { className: "skeleton bdrs:2 fz:14 fz:16:md-up lh:1.3 h:lh w:96 mb:0", style: { height: '1.16em', width: '7.5em', border: 'none' } }))));
};
export const HeadingDescriptionSkeleton = () => (React.createElement("div", { className: styles.description, style: { transform: 'translateY(0.2em)' } },
    React.createElement("span", { className: "skeleton bdrs:2 d:inline-block", style: { height: '1em', width: '85%' } }),
    React.createElement("span", { className: "skeleton bdrs:2 d:inline-block", style: { height: '1em', width: '95%' } }),
    MEDIA_BREAKPOINTS.XL_UP.matches &&
        React.createElement("span", { className: "skeleton bdrs:2 d:inline-block", style: { height: '1em', width: '55%' } })));
export const HeadingSkeleton = () => {
    const { pagePath } = useAlgoliaAppContext();
    return (React.createElement("div", { className: `d:grid ${styles.wrapper}` },
        React.createElement(HeadingTitleSkeleton, null),
        pagePath !== 'search' &&
            React.createElement("div", null,
                React.createElement(HeadingDescriptionSkeleton, null))));
};
